import { Tween, Easing } from '@tweenjs/tween.js';
import { formatCurrencyValue, getCurrencySymbol } from '../helper/currencies';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { isDesktop } from 'react-device-detect';
import HELPERS from '../../lib/globals/helpers/Helpers';

class WinAmountController {
  constructor(vc, conf) {
    this.vc = vc;
    this.config = conf;
    this.win = 0;
    this.totalWin = 0;
    if (this.vc.getChildByName(this.config.item, true)) {
      this.item = this.vc.getChildByName(this.config.item, true);
      this.item.alpha = 0;
      this.item.WIN_LABEL = this.vc.getChildByName('WIN_LABEL', true);
      this.item.WIN_VALUE = this.vc.getChildByName('WIN_VALUE', true);
      this.item.WIN_LABEL.anchor.x = 1;
      this.item.WIN_VALUE.anchor.x = 1;
      this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
      this.setWin();
    } else {
      throw new Error(
        'WinAmountController failed init ' + JSON.stringify(this.config)
      );
    }
    window.addEventListener(
      EVENTS.ICON_CLICKED,
      this.removeTween.bind(this),
      false
    );
    window.addEventListener(
      EVENTS.WIN_HIGHLIGHT,
      this.winHighlight.bind(this),
      false
    );
    window.addEventListener(
      EVENTS.REEL_FINISHED,
      this.reelsFinished.bind(this),
      false
    );
    window.addEventListener(
      EVENTS.BET_PLACED,
      this.betPlaced.bind(this),
      false
    );
    window.addEventListener(
      EVENTS.SERVER_MSG,
      this.serverMSG.bind(this),
      false
    );
  }

  removeTween() {
    if (this.tween) {
      this.win = this.totalWin;
      this.setWin();
      this.tween.stop();
      this.tween = null;
    }
  }

  winHighlight(e) {
    if (!e.detail.open) {
      this.removeTween();
    }
  }

  betPlaced(e) {
    if (e.detail.placed) {
      clearTimeout(this.timeout);
      if (this.totalWin > 0) {
        this.win = this.totalWin;
        this.setWin();
      }
      this.timeout = setTimeout(() => {
        this.anim(0);
      }, 500);
    }
  }
  serverMSG(e) {
    if (e.detail.service === 'bet') {
      // this.anim(0)
      this.totalWin = e.detail.data.totalWin;
    }
    if (e.detail.service === 'bonusstep') {
      // this.anim(0)
      this.totalWin = e.detail.data.win;
    }
    if (e.detail.service === 'freespinstep') {
      // this.anim(0)
      if (e.detail.data.winlines) {
        this.totalWin = 0;
        for (let index = 0; index < e.detail.data.winlines.length; index++) {
          this.totalWin = this.totalWin + e.detail.data.winlines[index].amount;
        }
      }
    }
  }

  resize(w, h) {
    if (!isDesktop) {
      if (w >= h) {
        this.item.WIN_LABEL.style.fontSize = 26;
        this.item.WIN_VALUE.style.fontSize = 30;
        this.item.WIN_LABEL.y = -50;
        this.item.WIN_VALUE.y = -24;
      } else {
        this.item.WIN_LABEL.style.fontSize = 16;
        this.item.WIN_VALUE.style.fontSize = 18;
        this.item.WIN_LABEL.y = 12;
        this.item.WIN_VALUE.y = 29;
      }
    } else {
      this.item.WIN_LABEL.style.fontSize = 16;
      this.item.WIN_VALUE.style.fontSize = 18;
      this.item.WIN_LABEL.y = -10;
      this.item.WIN_VALUE.y = 7;
    }
  }

  reelsFinished() {
    clearTimeout(this.timeout);
    if (this.totalWin > 0) {
      this.anim(1);
      // this.win = this.totalWin;
      // this.setWin();
      // this.item.WIN_VALUE.position.x = -this.item.WIN_VALUE.getBounds().width + this.item.WIN_VALUE.getBounds().x
      this.win = 0;
      this.updateWin(this.totalWin);
    } else {
      this.timeout = setTimeout(() => {
        this.anim(0);
      }, 500);
    }
  }

  setWin() {
    this.item.WIN_LABEL.text = 'WIN';
    this.item.WIN_VALUE.text = formatCurrencyValue(this.win, this.currency);
  }

  updateWin(a) {
    if (this.tween) {
      this.removeTween();
      return;
    }
    let time = 500;
    let delay = 0;
    let winLevels = HELPERS.getWinLevels();
    if (winLevels.length > 0) {
      time = winLevels[winLevels.length - 1].time;
      delay = 2000;
    }

    this.tween = new Tween(this)
      .to({ win: a }, time)
      .easing(Easing.Linear.None)
      .delay(delay)
      .onUpdate(() => {
        this.setWin();
      })
      .onComplete(() => {
        this.tween = null;
      })
      .start();
  }

  anim(alpha) {
    this.item.WIN_VALUE.text = '';
    this.item.WIN_LABEL.text = '';
    this.tweener = new Tween(this.item)
      .to({ alpha: alpha }, 100)
      .easing(Easing.Linear.None)
      .start();
  }
}

export default WinAmountController;
